import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthHeaderComponent } from '../../global/auth-header/auth-header.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FooterComponent } from "../../global/footer/footer.component";
import { MatIconModule } from '@angular/material/icon';
import { AuthenticationService } from '@/app/services/auth/authentication.service';
import { NgToastService } from 'ng-angular-popup';

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    MatCheckboxModule,
    FormsModule,
    AuthHeaderComponent,
    MatFormFieldModule,
    MatInputModule,
    FooterComponent,
    MatIconModule
],
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.css',
})
export class ChangePasswordComponent implements OnInit {
  viewPassword:boolean=false;
  email: string;

  changePasswordForm: FormGroup;
  isCheck = false;
  constructor(private fb: FormBuilder, private router: Router,
    private authservice: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private toast: NgToastService
  ) {
    this.changePasswordForm = this.fb.group({
      otp: ['', Validators.required],
      newpassword:['', [Validators.required, Validators.minLength(12)]],
      confirmpassword: ['', Validators.required],
    });
  }
  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.email = params['email'];
    });
  }

  onSubmit() {
    if (this.changePasswordForm.invalid) {
      this.changePasswordForm.markAllAsTouched();
      return;
    }
  
    // Create a FormData instance
    const formData = new FormData();
  
    // Append form values to FormData
    formData.append('password', this.changePasswordForm.get('newpassword')?.value);
    formData.append('password_confirmation', this.changePasswordForm.get('confirmpassword')?.value);
    formData.append('otp', this.changePasswordForm.get('otp')?.value);
    formData.append('email', this.email);
  
    // Call the service and send FormData
    this.authservice.changePassword(formData).subscribe({
      next: (response) => {
        console.log('Response:', response);
        this.toast.success( 'Password reset successfully!');
        this.router.navigate(['/login']);
      },
      error: (err) => {
        console.error('Error:', err);
        this.toast.danger(err.error.message, 'Failed to reset password', 4000);
      },
    });
  }
  
  
  
  navigateBack(){
    this.router.navigate(['/recover-account'])
  }
  navigateTo(){
   this.onSubmit();
  }
}
